import store from '../store/index'

const replaceCodeList = [12039, 13007, 11016, 11015];

export const getErrorMsgByStatusCode = (statuscode, value) => {
  debugger
  const lang = store.state.lang;
  const errorInforList = store.state.errorInfor || [];
  const data = errorInforList.find(param => param.Key === `${statuscode}`);

  if (!data) return '';

  let returnValue = { ...data };

  if (replaceCodeList.includes(Number(statuscode)) && !!value) {
    returnValue.Value = returnValue.Value.replace(/#.+#/, value);
  }

  if (returnValue.Value) return returnValue.Value;
  if (lang == 'zh-cn') return data.CnMessage || '未知错误，请重试';
  if (lang === 'en-us') return data.EnMessage || 'Unknown error, try again"';
}

// export function errMessage(statuscode, value) {
//   const msg = getErrorMsgByStatusCode(statuscode, value);

//   error()
// }